import { styled } from '@mui/material';

import { TabPanelContainer } from '~/components/TabComponents';

export const UserFormContainer = styled(TabPanelContainer)(({ theme }) => ({
  marginTop: theme.spacing(8),
}));
